import React, {Component} from 'react'
import PropTypes from 'prop-types'
import UserInfoBox from '../UserInfoBox/UserInfoBox'
import VeicoloLogo from '../../../assets/logo-veicolo.png'
import Threesome from '../../../assets/triangolo.png'

const TextUser = (props) => <div className={props.bold ? 'text-bold-user' : 'text-regular-user'}>{props.children}</div>

export default class UserAreaVehicles extends Component {
  constructor (props) {
    super(props)
    this.state = {
      vehicleEditing: {}
    }
  }

  render () {
    return (<div className="row">
      <div className="col-md-7">
        <div className="panel panel-default panel-border-login">
          <h2 className="login-title">
            VEICOLI
          </h2>
          <div className="panel-body">
            <div className="col-md-3"><img className="user-admin-logo" src={VeicoloLogo} /></div>
            {this.props.user.vehicles ? this.props.user.vehicles.map((item, index) => (
              <div key={item.id + '-' + item.index} className={'col-md-9' + (index > 0 ? ' col-md-push-3' : '')}>
                <div className="card">
                  <div className="caption">
                    <div className="col-md-12">
                      <p style={{fontSize: 13}}>{item.VehicleOwnershipType && item.VehicleOwnershipType.name}</p>
                      <h3 className="text-muted">{item.plate_number}</h3>
                      <p>{item.VehiclePowerSupply && item.VehiclePowerSupply.name}</p>
                    </div>
                  </div>
                </div>
              </div>)) : null}
          </div>
        </div>
      </div>

      <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
        <div className="information-container">
          <div style={{marginLeft: 30}}>
            <div style={{marginTop: 15, marginBottom: 10}}>
              <TextUser bold>VEICOLI</TextUser>
              <span className="threesom-span">
                <img src={Threesome} />
              </span>
              <TextUser>
                Questi sono i tuoi veicoli registrati
              </TextUser>
            </div>
          </div>
        </div>
      </div>

    </div>)
  }
}

UserAreaVehicles.defaultProps = {}

UserAreaVehicles.propTypes = {}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Vehicles/UserAreaVehicles.js